// LICENSE_CODE ZON
'use strict'; /*jslint react:true es6:true*/
import React from 'react';
import cn from 'classnames';
import {Root_zone} from '../root_zone';
import * as cns from './box.module.less';

function Inner_box({
    className,
    children,
    id,
    as,
    ['data-test-id']: test_id,
    styleless,
    style,
    root_only,
    ...rest
}, ref)
{
    const Tag = as ?? 'div';
    const Comp = root_only ? Root_zone : Tag;
    const additional = {};
    if (root_only&&as)
        additional.as = as;
    return <Comp className={cn(cns.root, styleless&&cns.root__styleless,
      className)} id={id} data-test-id={test_id} style={style} ref={ref}
      {...additional} {...rest}>
      {children}
    </Comp>;
}

export const Box = React.forwardRef(Inner_box);
